import type { ProductMainOffer, PriceHistory } from 'src/types';

import type { GAOfferStatus, GAPrice, GAPriceType } from './types';

export function getTypeFromStatus(
  status: GAOfferStatus | undefined
): GAPriceType {
  switch (status) {
    case 'international':
    case 'variant':
    case '':
      return 'normal';
    case undefined:
    case 'raw':
    default:
      return '';
  }
}

export function getGAPriceFromObject(
  price: ProductMainOffer | PriceHistory,
  status: GAOfferStatus | undefined
) {
  switch (price.__typename) {
    case 'ProductMainOffer':
      return price;
    case 'PriceHistory':
    default:
      return {
        ...price,
        type: getTypeFromStatus(status),
      };
  }
}

export function getGAPrice(
  price: ProductMainOffer | PriceHistory | number | undefined | null,
  status: GAOfferStatus | undefined
): GAPrice | ProductMainOffer | undefined | null {
  return typeof price === 'object' && price !== null
    ? getGAPriceFromObject(price, status)
    : {
        price,
        type: getTypeFromStatus(status),
      };
}

export function getGAFeatured(featured: boolean) {
  return featured ? 'Featured' : 'Not Featured';
}
